import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import pdf from "../../../../image/pdf.jpg";
import uploadImage from "../../../../image/wmremove-transformed-Photorooms.jpg";
import {
  barClubAddRequest,
  barClubResetState,
} from "../../../../redux/barclub/BarClubAction";
import { wholesalerViewAllRequest } from "../../../../redux/wholesaler/WholesalerAction";
import "../../../../style/style.css";
import { StyledContainer, styles } from "../../../components/formStyles";
import CustomButton from "../../../constant/commonButton";
import ReusableFormFields from "../../../constant/reusableFormFields";
import { mapBackendMessage } from "../../../notification/BackendMessage";
import CommonDialog from "../../../notification/Dialogbox";
import CommonSnackbar from "../../../notification/Snackbar";

const AddClub = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [imageFileName, setImageFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [proofFileName, setProofFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [proofSelected, setProofSelected] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [proofPreview, setProofPreview] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const fileInputRef = useRef(null);
  const proofInputRef = useRef(null);

  const addBarClubState = useSelector((state) => state?.barClub || {});

  const wholesalerViewAllState = useSelector(
    (state) => state?.wholesaler?.viewAllWholesalers || {}
  );
  const wholesalerList = wholesalerViewAllState?.data?.data || [];

  useEffect(() => {
    dispatch(wholesalerViewAllRequest());
  }, [dispatch]);

  const dynamicWholesalerOptions = wholesalerList?.map((wholesaler) => ({
    value: wholesaler?.id,
    label: wholesaler?.first_name + " " + wholesaler?.last_name,
  }));

  const inputFields = [
    {
      name: "wholesaler_id",
      label: "Choose Wholesaler",
      type: "select",
      options: dynamicWholesalerOptions,
      rules: { required: "Wholesaler Name is required" },
    },
    {
      name: "name",
      label: "Name",
      rules: { required: "Name is required" },
    },
    {
      name: "first_name",
      label: "First Name",
      rules: { required: "First Name is required" },
    },
    {
      name: "last_name",
      label: "Last Name",
      rules: { required: "Last Name is required" },
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{8,}$/,
          message: "Invalid Phone Number",
        },
      },
    },
    {
      name: "address",
      label: "Address",
      rules: { required: "Address is required" },
    },
    {
      name: "google_map_location",
      label: "Google Map Location",
      rules: {
        required: "Google Map Location is required",
      },
    },
    {
      name: "latitude",
      label: "Latitude",
      rules: {
        required: "Latitude is required",
      },
    },
    {
      name: "longitude",
      label: "Longitude",
      rules: {
        required: "Longitude is required",
      },
    },
    {
      name: "shop_open_and_close_time",
      label: "Shop Open and Close time",
      rules: { required: "Shop Open and Close time is required" },
    },
  ];

  const MAX_FILE_SIZE = 200 * 1024;
  const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png"];
  const PROOF_ALLOWED_FILE_TYPES = [
    "image/jpeg",
    "image/png",
    "application/pdf",
  ];

  const readFile = (file, onLoadCallback) => {
    const reader = new FileReader();
    reader.onload = () => onLoadCallback(reader.result);
    reader.readAsDataURL(file);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        showSnackbar("Please select a file smaller than 200kB.", "error");
        return;
      }
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        showSnackbar(
          "Invalid file type. Only JPEG and PNG are allowed.",
          "error"
        );
        return;
      }
      readFile(file, (result) => {
        const base64String = result.split(",")[1];
        setSelectedFile(base64String);
        setImagePreview(URL.createObjectURL(file));
        setImageFileName(file.name);
        setValue("fileName", file.name);
      });
    }
  };

  const handleProofChange = (event) => {
    const proof = event.target.files[0];
    if (proof) {
      if (proof.size > MAX_FILE_SIZE) {
        showSnackbar("Please select a file smaller than 200kB.", "error");
        return;
      }
      if (!PROOF_ALLOWED_FILE_TYPES.includes(proof.type)) {
        showSnackbar(
          "Invalid file type. Only JPEG, PNG and PDF are allowed.",
          "error"
        );
        return;
      }
      readFile(proof, (result) => {
        const base64String = result.split(",")[1];
        setProofSelected(base64String);

        if (proof.type === "application/pdf") {
          setProofPreview(pdf);
        } else {
          setProofPreview(URL.createObjectURL(proof));
        }
        setProofFileName(proof.name);
        setValue("proofName", proof.name);
      });
    }
  };

  const handleImage = () => {
    if (selectedFile) {
      showSnackbar(
        `Product details saved with file: ${selectedFile.name}`,
        "success"
      );
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const proofImage = () => {
    if (proofSelected) {
      showSnackbar(
        `Product details saved with file: ${proofSelected.name}`,
        "success"
      );
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  // const onSubmit = (data) => {
  //   setIsLoading(true);
  //   if (!selectedFile || !proofSelected) {
  //     showSnackbar("Please select both image and proof files.", "error");
  //     setIsLoading(false);
  //     return;
  //   }
  //   const newBarClubData = {
  //     ...data,
  //     bar_img_url: selectedFile,
  //     govt_img_url: proofSelected,
  //   };

  //   setLocalBarClubData((prevData) => [...prevData, newBarClubData]);
  //   setDialogMessage("Bar Details Aggregated Successfully", "success");
  //   setIsSuccess(true);
  //   setDialogOpen(true);
  //   reset({
  //     type_of_quantity: "",
  //     wholesaler_name: "",
  //     address: "",
  //     google_map_location: "",
  //     latitude: "",
  //     longitude: "",
  //     shop_open_and_close_time: "",
  //   });
  //   setSelectedFile(null);
  //   setImagePreview(null);
  //   setImageFileName("");
  //   if (fileInputRef.current) fileInputRef.current.value = "";

  //   setProofSelected(null);
  //   setProofPreview(null);
  //   setProofFileName("");
  //   if (proofInputRef.current) proofInputRef.current.value = "";
  //   setIsLoading(false);
  // };

  const handleCancel = () => {
    reset({
      wholesaler_id: "",
      name: "",
      first_name: "",
      last_name: "",
      type_of_quantity: "",
      wholesaler_name: "",
      address: "",
      google_map_location: "",
      latitude: "",
      longitude: "",
      shop_open_and_close_time: "",
    });
    setSelectedFile(null);
    setImagePreview(null);
    setImageFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";

    setProofSelected(null);
    setProofPreview(null);
    setProofFileName("");
    if (proofInputRef.current) proofInputRef.current.value = "";
    setIsLoading(false);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    if (!selectedFile) {
      showSnackbar("Please choose a file before saving.", "error");
      setIsLoading(false);
      return;
    }
    if (!proofSelected) {
      showSnackbar("Please choose a proof file before saving.", "error");
      setIsLoading(false);
      return;
    }

    const formData = {
      ...data,
      bar_img_url: selectedFile,
      govt_img_url: proofSelected,
    };

    dispatch(barClubAddRequest(formData));
    reset();
    setIsLoading(false);
  };

  const resetFileInputs = () => {
    setSelectedFile(null);
    setImagePreview(null);
    setImageFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";

    setProofSelected(null);
    setProofPreview(null);
    setProofFileName("");
    if (proofInputRef.current) proofInputRef.current.value = "";
  };

  const handleBarClubResponse = () => {
    setIsLoading(false);
    if (addBarClubState?.addBarClub?.error) {
      const customMessage = mapBackendMessage(
        addBarClubState?.addBarClub?.errormessage
      );
      setDialogMessage(customMessage);
      setIsSuccess(false);
      setDialogOpen(true);
      dispatch(barClubResetState());
    } else if (addBarClubState?.addBarClub?.success) {
      setDialogMessage("Bar Details Aggregated Successfully");
      setIsSuccess(true);
      setDialogOpen(true);
      reset({
        wholesaler_id: "",
        name: "",
        first_name: "",
        last_name: "",
        type_of_quantity: "",
        wholesaler_name: "",
        address: "",
        google_map_location: "",
        latitude: "",
        longitude: "",
        shop_open_and_close_time: "",
      });
      resetFileInputs();
      dispatch(barClubResetState());
    }
  };
  useEffect(handleBarClubResponse, [addBarClubState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography variant="h5" gutterBottom sx={styles.title}>
                Add New with Bar/Club
              </Typography>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Add Minimum 2 Images Bar/Club
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                    <img
                      src={imagePreview || uploadImage}
                      alt="Image"
                      width={80}
                      height={80}
                      style={styles.image}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Bar/Club, size less than 200KB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          ref={fileInputRef}
                          onChange={handleFileChange}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(selectedFile)}
                        // disabled={!imageFileName}
                      >
                        {imageFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box sx={styles.fileBoxContainer}>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Minimum 2 Govt ID Proof Of Bar/club
              </Typography>
              <StyledContainer>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                    <img
                      src={proofPreview || uploadImage}
                      alt="Proof"
                      width={80}
                      height={80}
                      style={styles.image}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Proof, size less than 200KB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        text="Choose File"
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          ref={proofInputRef}
                          onChange={handleProofChange}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(proofSelected)}
                        // disabled={!proofFileName}
                      >
                        {proofFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={proofImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG, PDF & PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
            />

            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={addBarClubState?.addBarClub?.inProgress}
                    loading={addBarClubState?.addBarClub?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />
    </Container>
  );
};

export default AddClub;
